"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tab = _interopRequireDefault(require("../../../components/common/Tab/Tab"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _OrderHistoryComponents = _interopRequireDefault(require("../../../components/OrderHistoryComponents"));
var _MarginOrderHistory = _interopRequireDefault(require("../../../components/OrderHistoryComponents/MarginOrderHistory"));
var _InstrumentRow = _interopRequireDefault(require("../../../components/InstrumentRow"));
var _TradingLayoutCharts1280Px = _interopRequireDefault(require("../../Responsive/TrandingLayout/TradingLayoutCharts1280Px"));
var _PriceChartContainer = _interopRequireDefault(require("../../../components/PriceChart/PriceChartContainer"));
var _DepthChartContainer = _interopRequireDefault(require("../../../components/DepthChart/DepthChartContainer"));
var _config = _interopRequireDefault(require("../../../config"));
var _ConfirmLimitOrderModalContainer = _interopRequireDefault(require("../../../components/ConfirmLimitOrderModal/ConfirmLimitOrderModalContainer"));
var _MarginClosePositionModal = _interopRequireDefault(require("../../../components/MarginClosePosition/MarginClosePositionModal"));
var _MarginTransferAssetsModal = _interopRequireDefault(require("../../../components/MarginTransferAssetModal/MarginTransferAssetsModal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var orderEntryClasses = (0, _cssClassesHelper.getBEMClasses)('order-entry');
var orderBookClasses = (0, _cssClassesHelper.getBEMClasses)('order-book');
var recentTradeClasses = (0, _cssClassesHelper.getBEMClasses)('recent-trade');
var flexTableClasses = (0, _cssClassesHelper.getBEMClasses)('flex-table');
var tradingLayoutClasses = (0, _cssClassesHelper.getBEMClasses)('trading-layout');
var TradingLayout1440Px = function TradingLayout1440Px(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var renderActivity = function renderActivity() {
    var config = props.config,
      isMarginActive = props.isMarginActive;
    var usePagination = config.OrderHistoryData.usePagination,
      maxLines = config.TradingLayout.maxLines;
    var orderHistoryConfig = {
      usePagination: usePagination,
      maxLines: maxLines,
      filterMode: 'selectedInstrument'
    };
    return isMarginActive ? /*#__PURE__*/_react["default"].createElement(_MarginOrderHistory["default"], {
      config: orderHistoryConfig
    }) : /*#__PURE__*/_react["default"].createElement(_OrderHistoryComponents["default"], {
      config: orderHistoryConfig
    });
  };
  var OrderBook = props.OrderBook,
    RecentTrades = props.RecentTrades,
    OrderEntry = props.OrderEntry,
    InstrumentPositions = props.InstrumentPositions,
    _short = props["short"],
    isMarginEnabledSelector = props.isMarginEnabledSelector;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(tradingLayoutClasses('row'), " ").concat(isMarginEnabledSelector ? 'margin-row' : '')
  }, /*#__PURE__*/_react["default"].createElement(_InstrumentRow["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('body')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('chart-container')
  }, !_short ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('chart-header')
  }, t('Price Chart')), /*#__PURE__*/_react["default"].createElement(_PriceChartContainer["default"], null), _config["default"].TradingLayout.showDepthChart && /*#__PURE__*/_react["default"].createElement(_DepthChartContainer["default"], null)) : /*#__PURE__*/_react["default"].createElement(_TradingLayoutCharts1280Px["default"], {
    "short": _short,
    PriceChart: _PriceChartContainer["default"],
    DepthChart: _DepthChartContainer["default"],
    showDepthChart: _config["default"].TradingLayout.showDepthChart
  })), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: orderBookClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: flexTableClasses('title')
  }, t('Order Book')), /*#__PURE__*/_react["default"].createElement(OrderBook, null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: recentTradeClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: flexTableClasses('title')
  }, t('Recent Trades')), /*#__PURE__*/_react["default"].createElement(RecentTrades, null)), _short ? /*#__PURE__*/_react["default"].createElement("div", {
    className: orderEntryClasses('container')
  }, /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
    customClass: "trading-layout",
    panes: [{
      menuItem: t('Order Entry'),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(OrderEntry, null);
      }
    }, {
      menuItem: t('Balances'),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(InstrumentPositions, {
          showTitle: false
        });
      }
    }]
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: orderEntryClasses('container')
  }, /*#__PURE__*/_react["default"].createElement(OrderEntry, {
    title: /*#__PURE__*/_react["default"].createElement("div", {
      className: flexTableClasses('title')
    }, t('Order Entry'))
  }), /*#__PURE__*/_react["default"].createElement(InstrumentPositions, null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: tradingLayoutClasses('activity-container')
  }, renderActivity()))), /*#__PURE__*/_react["default"].createElement(_ConfirmLimitOrderModalContainer["default"], null), isMarginEnabledSelector && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MarginClosePositionModal["default"], null), /*#__PURE__*/_react["default"].createElement(_MarginTransferAssetsModal["default"], null)));
};
TradingLayout1440Px.propTypes = {
  OrderBook: _propTypes["default"].func.isRequired,
  RecentTrades: _propTypes["default"].func.isRequired,
  OrderEntry: _propTypes["default"].func.isRequired,
  InstrumentPositions: _propTypes["default"].func.isRequired,
  "short": _propTypes["default"].bool
};
var _default = exports["default"] = TradingLayout1440Px;